import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import _ from "lodash";
import * as echarts from "echarts";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookie from "vue-cookie";
import scroll from "vue-seamless-scroll";
// import "lib-flexible"; // 禁用lib-flexible，改用纯CSS响应式
import animated from "animate.css";
import {digitalFlop} from "@jiaminghi/data-view";
import "./style/index.less";
import "./service/api/axios";
import "./utils/dependence";

// 开发环境启用Mock数据
// 注意：由于页面1和页面2已接入真实API，这里暂时禁用全局Mock
// 如果需要启用递归侧Mock，请取消下面的注释
// if (process.env.NODE_ENV === "development") {
//   require("./mock");
// }

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development";

Vue.use(VueCookie);
Vue.use(ElementUI);
Vue.use(scroll);
Vue.use(animated);
Vue.use(digitalFlop);
Vue.prototype.$echarts = echarts;
Vue.prototype._ = _;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

